/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { memo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import CableIcon from '@mui/icons-material/Cable';
import ShieldIcon from '@mui/icons-material/ShieldOutlined';
import { Grid, Tab, Tabs } from '@mui/material';

import { TabPanel } from '../../../../components/TabPanel/TabPanel';
import { Namespaces } from '../../../../i18n';
import { useNavTabsStyles } from '../../../../styles/navigationTabs';
import { ClusterUpdateRequestBody } from '../../../../types/cluster/ClusterUpdateRequestBody';
import { UpdateClusterDetailsParameterIdentification } from '../../../../types/cluster/UpdateClusterDetailsParameterIdentification';
import { ACLTabStyles } from './ACLTab.styles';
import { FirewallSettings } from './components/FirewallSettings/FirewallSettings';
import { PgHba } from './components/PgHba/PgHba';

type ACLTabProps = {
  updateData: (data: ClusterUpdateRequestBody) => Promise<unknown>;
  identificationData: UpdateClusterDetailsParameterIdentification;
};

export const ACLTab = memo<ACLTabProps>(props => {
  const { updateData, identificationData } = props;
  const { t } = useTranslation(Namespaces.Cluster);

  const classes = ACLTabStyles();
  const tabsClasses = useNavTabsStyles();

  const [value, setValue] = useState(0);

  const handleChangeTab = (_e: any, value: number) => {
    setValue(value);
  };

  return (
    <Grid classes={{ root: classes.root }}>
      <Tabs
        aria-label="cluster acl tabs"
        indicatorColor="primary"
        scrollButtons={false}
        value={value}
        classes={{ root: tabsClasses.root }}
        className={classes.tabs}
        onChange={handleChangeTab}
        TabIndicatorProps={{ style: { display: 'none' } }}
        orientation="horizontal"
      >
        <Tab
          data-cy="cluster-acl-firewall-settings-tab"
          label={t('details.acl.firewall.title')}
          icon={<ShieldIcon />}
          iconPosition="start"
        />
        <Tab
          data-cy="cluster-pg-hba-tab"
          label={t('details.acl.pg_hba.title')}
          icon={<CableIcon />}
          iconPosition="start"
        />
      </Tabs>
      <TabPanel value={value} index={0}>
        <FirewallSettings updateData={updateData} identificationData={identificationData} />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <PgHba updateData={updateData} identificationData={identificationData} />
      </TabPanel>
    </Grid>
  );
});
